import {
  View,
  ToggleGroup,
  Flex,
  Text,
  Options,
  Menu,
  IconButton,
  IconSettingsLine,
  Badge,
  Tag,
} from '@instructure/ui';
import useAppStore from '../../stores/app';
import TimeElapsed from '../Common/TimeElapsed';
import { useEffect, useState } from 'react';
const ProctorsOnline = () => {
  const { proctors } = useAppStore();
  const [proctorList, setProctorList] = useState([]);

  useEffect(() => {
    // Sort so the oldest stay on the bottom...
    const sortedProctors = Object.values(proctors).sort((a, b) => {
      return new Date(b.entered) - new Date(a.entered);
    });
    setProctorList(sortedProctors);
  }, [proctors]);

  const renderOptionsMenu = () => {
    return (
      <Menu
        placement="bottom end"
        shouldContainFocus
        shouldReturnFocus
        mountNode={() => document.body} // Ensures the menu overlays everything
        trigger={
          <IconButton
            withBackground={false}
            withBorder={false}
            color="primary"
            size="small"
            screenReaderLabel="Session Options"
            margin="none"
            padding="none"
          >
            <IconSettingsLine />
          </IconButton>
        }
      >
        <Menu.Item>
          <Text>Message</Text>
        </Menu.Item>
        <Menu.Separator />
        <Menu.Item>
          <Text>Kick Out</Text>{' '}
        </Menu.Item>
      </Menu>
    );
  };

  return (
    <>
      <ToggleGroup
        toggleLabel="This is the toggle that shows what proctors are online."
        summary={
          <Flex justifyItems="space-between" margin="none small none none">
            <Flex.Item>Proctors Online</Flex.Item>

            {proctorList.length && (
              <Flex.Item>
                <Badge
                  count={proctorList.length}
                  variant="success"
                  pulse={true}
                  standalone
                />
              </Flex.Item>
            )}
          </Flex>
        }
        defaultExpanded
      >
        {proctorList.length ? (
          <Options>
            {proctorList.map((proctor) => (
              <Options.Item
                key={`session_waiting_${proctor.sid}`}
                //renderAfterLabel={renderOptionsMenu(sessionSid)}
                beforeLabelContentVAlign="start"
                afterLabelContentVAlign="start"
              >
                <Flex justifyItems="space-between" padding="none">
                  <Flex.Item width="3.2rem">
                    <Tag
                      size="small"
                      text={<TimeElapsed since={proctor.entered} />}
                    />
                  </Flex.Item>
                  <Flex.Item textAlign="start" shouldGrow>
                    {proctor.firstName} {proctor.lastName}
                  </Flex.Item>
                  <Flex.Item width="2rem" textAlign="end">
                    {renderOptionsMenu(proctor.sid)}
                  </Flex.Item>
                </Flex>
              </Options.Item>
            ))}
          </Options>
        ) : (
          <View as="div" padding="small" textAlign="center">
            <Text>No other proctors in the roomg</Text>
          </View>
        )}
      </ToggleGroup>
    </>
  );
};

export default ProctorsOnline;
